import classNames from "classnames";
import AscButton from "../../AscButton/AscButton";
import {
  CheckDisabledIcon,
  ClassicChevronRightIcon,
  // LockIcon,
} from "../../AscIcons";
import AscProgressBar from "../../AscProgressBar/AscProgressBar";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscTrackCard.module.scss";
import TrackPlaceholder from "../../../assets/images/track-placeholder.svg";
export interface AscTrackCardProps {
  title: string;
  imageUrl?: string;
  grade?: number;
  completedModules?: number;
  totalModules?: number;
  isSkillCardForDashboard?: boolean;
  completedPercentage?: number;
  loading?: boolean;
  locked?: boolean;
  className?: string;
  onButtonClick?: () => void;
}

export default function AscTrackCard({
  title,
  imageUrl,
  grade = 0,
  completedModules = 0,
  totalModules = 1,
  isSkillCardForDashboard = false,
  completedPercentage = 0,
  loading = false,
  locked = false,
  className,
  onButtonClick,
}: AscTrackCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className, {
        [styles.completed]:
          (isSkillCardForDashboard ? completedPercentage : grade) >= 100,
      })}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      coverImageUrl={imageUrl}
      fallbackCoverImageUrl={TrackPlaceholder}
      imageClassName={
        isSkillCardForDashboard
          ? styles.fullWidthHeightCardImage
          : styles.cardImage
      }
      contentClassName={styles.cardContent}
      title={title}
      footerClassName={styles.cardFooter}
      footer={
        isSkillCardForDashboard ? null : (
          <CheckDisabledIcon
            className={styles.checkIcon}
            data-testid="asc-skill-card-check-mark-icon"
          />
        )
      }
      loading={loading}
    >
      <div className={styles.progressContent}>
        {/* temporary removing this logic */}
        {/* {loading || locked ? (
          <div className={styles.lockedContainer}>
            <div className={styles.box}>
              <LockIcon
                className={styles.lockIcon}
                data-testid="asc-skill-card-lock-icon"
              />
            </div>
            Locked
          </div>
        ) : (
          <> */}
            <AscProgressBar
              value={isSkillCardForDashboard ? completedPercentage : grade}
              max={100}
              fullWidth
              className={styles.progressBar}
            />
            <div className={styles.bottomContent}>
              <div className={styles.textContainer}>
                {isSkillCardForDashboard ? "Completed:" : "Grade:"}
                <span className={styles.numberText}>
                  {isSkillCardForDashboard
                    ? Math.round(completedPercentage)
                    : Math.round(grade)}
                  %
                </span>
              </div>
              <div className={styles.textContainer}>
                Modules:
                <span className={styles.numberText}>
                  {completedModules || 0}/{totalModules}
                </span>
              </div>
            </div>
          {/* </> */}
        {/* )} */}
      </div>
      <AscButton
        // disabled={locked}
        iconClassName={styles.actionButtonIcon}
        className={styles.actionButton}
        squarishIcon
        icon={<ClassicChevronRightIcon />}
        onClick={onButtonClick}
      />
    </AscGenericCard>
  );
}
